<template>
	<section class="djcontainer-nogrid">
		<slot></slot>
	</section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "AdaptiveContainerWithoutGrid",
});
</script>
